// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "unity_build.proto" (package "unity_build", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "unity_build.proto" (package "unity_build", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class GetContractsRequest$Type extends MessageType {
    constructor() {
        super("unity_build.GetContractsRequest", [
            { no: 1, name: "custom_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string custom_ids */ 1:
                    message.customIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string custom_ids = 1; */
        for (let i = 0; i < message.customIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.customIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.GetContractsRequest
 */
export const GetContractsRequest = new GetContractsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContractsResponse$Type extends MessageType {
    constructor() {
        super("unity_build.GetContractsResponse", [
            { no: 1, name: "contracts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Contract },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "found_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "not_found_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contracts = [];
        message.success = false;
        message.message = "";
        message.foundIds = [];
        message.notFoundIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated unity_build.Contract contracts */ 1:
                    message.contracts.push(Contract.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* repeated string found_ids */ 4:
                    message.foundIds.push(reader.string());
                    break;
                case /* repeated string not_found_ids */ 5:
                    message.notFoundIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated unity_build.Contract contracts = 1; */
        for (let i = 0; i < message.contracts.length; i++)
            Contract.internalBinaryWrite(message.contracts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* repeated string found_ids = 4; */
        for (let i = 0; i < message.foundIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.foundIds[i]);
        /* repeated string not_found_ids = 5; */
        for (let i = 0; i < message.notFoundIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.notFoundIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.GetContractsResponse
 */
export const GetContractsResponse = new GetContractsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetContractByCustomIdRequest$Type extends MessageType {
    constructor() {
        super("unity_build.GetContractByCustomIdRequest", [
            { no: 1, name: "custom_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string custom_id */ 1:
                    message.customId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string custom_id = 1; */
        if (message.customId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.GetContractByCustomIdRequest
 */
export const GetContractByCustomIdRequest = new GetContractByCustomIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Contract$Type extends MessageType {
    constructor() {
        super("unity_build.Contract", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "custom_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "last_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "contract_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "contract_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "associated_estimates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssociatedEstimate },
            { no: 9, name: "prime_contract_value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "prime_contract_total_approved_change_orders", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "prime_contract_total_current_contract_value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "total_budget_labor_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "total_budget", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 14, name: "project_urls", kind: "message", T: () => ProjectUrls }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.customId = "";
        message.createdBy = 0;
        message.dateCreated = "";
        message.lastUpdated = "";
        message.contractName = "";
        message.contractDescription = "";
        message.associatedEstimates = [];
        message.primeContractValue = 0;
        message.primeContractTotalApprovedChangeOrders = 0;
        message.primeContractTotalCurrentContractValue = 0;
        message.totalBudgetLaborHours = 0;
        message.totalBudget = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string custom_id */ 2:
                    message.customId = reader.string();
                    break;
                case /* int32 created_by */ 3:
                    message.createdBy = reader.int32();
                    break;
                case /* string date_created */ 4:
                    message.dateCreated = reader.string();
                    break;
                case /* string last_updated */ 5:
                    message.lastUpdated = reader.string();
                    break;
                case /* string contract_name */ 6:
                    message.contractName = reader.string();
                    break;
                case /* string contract_description */ 7:
                    message.contractDescription = reader.string();
                    break;
                case /* repeated unity_build.AssociatedEstimate associated_estimates */ 8:
                    message.associatedEstimates.push(AssociatedEstimate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* float prime_contract_value */ 9:
                    message.primeContractValue = reader.float();
                    break;
                case /* float prime_contract_total_approved_change_orders */ 10:
                    message.primeContractTotalApprovedChangeOrders = reader.float();
                    break;
                case /* float prime_contract_total_current_contract_value */ 11:
                    message.primeContractTotalCurrentContractValue = reader.float();
                    break;
                case /* float total_budget_labor_hours */ 12:
                    message.totalBudgetLaborHours = reader.float();
                    break;
                case /* float total_budget */ 13:
                    message.totalBudget = reader.float();
                    break;
                case /* unity_build.ProjectUrls project_urls */ 14:
                    message.projectUrls = ProjectUrls.internalBinaryRead(reader, reader.uint32(), options, message.projectUrls);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string custom_id = 2; */
        if (message.customId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customId);
        /* int32 created_by = 3; */
        if (message.createdBy !== 0)
            writer.tag(3, WireType.Varint).int32(message.createdBy);
        /* string date_created = 4; */
        if (message.dateCreated !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateCreated);
        /* string last_updated = 5; */
        if (message.lastUpdated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.lastUpdated);
        /* string contract_name = 6; */
        if (message.contractName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.contractName);
        /* string contract_description = 7; */
        if (message.contractDescription !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.contractDescription);
        /* repeated unity_build.AssociatedEstimate associated_estimates = 8; */
        for (let i = 0; i < message.associatedEstimates.length; i++)
            AssociatedEstimate.internalBinaryWrite(message.associatedEstimates[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* float prime_contract_value = 9; */
        if (message.primeContractValue !== 0)
            writer.tag(9, WireType.Bit32).float(message.primeContractValue);
        /* float prime_contract_total_approved_change_orders = 10; */
        if (message.primeContractTotalApprovedChangeOrders !== 0)
            writer.tag(10, WireType.Bit32).float(message.primeContractTotalApprovedChangeOrders);
        /* float prime_contract_total_current_contract_value = 11; */
        if (message.primeContractTotalCurrentContractValue !== 0)
            writer.tag(11, WireType.Bit32).float(message.primeContractTotalCurrentContractValue);
        /* float total_budget_labor_hours = 12; */
        if (message.totalBudgetLaborHours !== 0)
            writer.tag(12, WireType.Bit32).float(message.totalBudgetLaborHours);
        /* float total_budget = 13; */
        if (message.totalBudget !== 0)
            writer.tag(13, WireType.Bit32).float(message.totalBudget);
        /* unity_build.ProjectUrls project_urls = 14; */
        if (message.projectUrls)
            ProjectUrls.internalBinaryWrite(message.projectUrls, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.Contract
 */
export const Contract = new Contract$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProjectUrls$Type extends MessageType {
    constructor() {
        super("unity_build.ProjectUrls", [
            { no: 1, name: "planroom_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "contract_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.planroomUrl = "";
        message.contractUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string planroom_url */ 1:
                    message.planroomUrl = reader.string();
                    break;
                case /* string contract_url */ 2:
                    message.contractUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string planroom_url = 1; */
        if (message.planroomUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.planroomUrl);
        /* string contract_url = 2; */
        if (message.contractUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.contractUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.ProjectUrls
 */
export const ProjectUrls = new ProjectUrls$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssociatedEstimate$Type extends MessageType {
    constructor() {
        super("unity_build.AssociatedEstimate", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "custom_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "last_updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "estimate_template_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "last_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "estimator_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "master_format_division_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "master_format_division_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "estimate_status_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "estimate_budget", kind: "message", T: () => ContractBudget },
            { no: 17, name: "associated_change_orders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssociatedChangeOrder },
            { no: 18, name: "mapped_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "is_prime_project", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "progress", kind: "message", T: () => AssociatedEstimateProgress }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.createdBy = 0;
        message.description = "";
        message.dueDate = "";
        message.dateCreated = "";
        message.name = "";
        message.customId = "";
        message.lastUpdatedBy = 0;
        message.estimateTemplateId = 0;
        message.lastUpdated = "";
        message.estimatorId = 0;
        message.masterFormatDivisionName = "";
        message.masterFormatDivisionId = "";
        message.estimateStatusName = "";
        message.associatedChangeOrders = [];
        message.mappedDepartmentId = 0;
        message.isPrimeProject = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 created_by */ 2:
                    message.createdBy = reader.int32();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string due_date */ 5:
                    message.dueDate = reader.string();
                    break;
                case /* string date_created */ 6:
                    message.dateCreated = reader.string();
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                case /* string custom_id */ 8:
                    message.customId = reader.string();
                    break;
                case /* int32 last_updated_by */ 9:
                    message.lastUpdatedBy = reader.int32();
                    break;
                case /* int32 estimate_template_id */ 10:
                    message.estimateTemplateId = reader.int32();
                    break;
                case /* string last_updated */ 11:
                    message.lastUpdated = reader.string();
                    break;
                case /* int32 estimator_id */ 12:
                    message.estimatorId = reader.int32();
                    break;
                case /* string master_format_division_name */ 13:
                    message.masterFormatDivisionName = reader.string();
                    break;
                case /* string master_format_division_id */ 14:
                    message.masterFormatDivisionId = reader.string();
                    break;
                case /* string estimate_status_name */ 15:
                    message.estimateStatusName = reader.string();
                    break;
                case /* unity_build.ContractBudget estimate_budget */ 16:
                    message.estimateBudget = ContractBudget.internalBinaryRead(reader, reader.uint32(), options, message.estimateBudget);
                    break;
                case /* repeated unity_build.AssociatedChangeOrder associated_change_orders */ 17:
                    message.associatedChangeOrders.push(AssociatedChangeOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 mapped_department_id */ 18:
                    message.mappedDepartmentId = reader.int32();
                    break;
                case /* bool is_prime_project */ 19:
                    message.isPrimeProject = reader.bool();
                    break;
                case /* unity_build.AssociatedEstimateProgress progress */ 20:
                    message.progress = AssociatedEstimateProgress.internalBinaryRead(reader, reader.uint32(), options, message.progress);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 created_by = 2; */
        if (message.createdBy !== 0)
            writer.tag(2, WireType.Varint).int32(message.createdBy);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string due_date = 5; */
        if (message.dueDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dueDate);
        /* string date_created = 6; */
        if (message.dateCreated !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateCreated);
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        /* string custom_id = 8; */
        if (message.customId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customId);
        /* int32 last_updated_by = 9; */
        if (message.lastUpdatedBy !== 0)
            writer.tag(9, WireType.Varint).int32(message.lastUpdatedBy);
        /* int32 estimate_template_id = 10; */
        if (message.estimateTemplateId !== 0)
            writer.tag(10, WireType.Varint).int32(message.estimateTemplateId);
        /* string last_updated = 11; */
        if (message.lastUpdated !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.lastUpdated);
        /* int32 estimator_id = 12; */
        if (message.estimatorId !== 0)
            writer.tag(12, WireType.Varint).int32(message.estimatorId);
        /* string master_format_division_name = 13; */
        if (message.masterFormatDivisionName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.masterFormatDivisionName);
        /* string master_format_division_id = 14; */
        if (message.masterFormatDivisionId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.masterFormatDivisionId);
        /* string estimate_status_name = 15; */
        if (message.estimateStatusName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.estimateStatusName);
        /* unity_build.ContractBudget estimate_budget = 16; */
        if (message.estimateBudget)
            ContractBudget.internalBinaryWrite(message.estimateBudget, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated unity_build.AssociatedChangeOrder associated_change_orders = 17; */
        for (let i = 0; i < message.associatedChangeOrders.length; i++)
            AssociatedChangeOrder.internalBinaryWrite(message.associatedChangeOrders[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* int32 mapped_department_id = 18; */
        if (message.mappedDepartmentId !== 0)
            writer.tag(18, WireType.Varint).int32(message.mappedDepartmentId);
        /* bool is_prime_project = 19; */
        if (message.isPrimeProject !== false)
            writer.tag(19, WireType.Varint).bool(message.isPrimeProject);
        /* unity_build.AssociatedEstimateProgress progress = 20; */
        if (message.progress)
            AssociatedEstimateProgress.internalBinaryWrite(message.progress, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.AssociatedEstimate
 */
export const AssociatedEstimate = new AssociatedEstimate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssociatedEstimateProgress$Type extends MessageType {
    constructor() {
        super("unity_build.AssociatedEstimateProgress", [
            { no: 1, name: "percent_complete", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "budget_override", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "total_contract_value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "earned_income", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "billed_income", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "retained_income", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "total_billed_due", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "total_billed_paid", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "over_under_billed", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "suggested_catch_up_billing", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "cost_to_complete", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "estimated_gross_margin", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "estimated_gross_margin_percentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.percentComplete = 0;
        message.budgetOverride = 0;
        message.totalContractValue = 0;
        message.earnedIncome = 0;
        message.billedIncome = 0;
        message.retainedIncome = 0;
        message.totalBilledDue = 0;
        message.totalBilledPaid = 0;
        message.overUnderBilled = 0;
        message.suggestedCatchUpBilling = 0;
        message.costToComplete = 0;
        message.estimatedGrossMargin = 0;
        message.estimatedGrossMarginPercentage = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float percent_complete */ 1:
                    message.percentComplete = reader.float();
                    break;
                case /* float budget_override */ 2:
                    message.budgetOverride = reader.float();
                    break;
                case /* float total_contract_value */ 3:
                    message.totalContractValue = reader.float();
                    break;
                case /* float earned_income */ 4:
                    message.earnedIncome = reader.float();
                    break;
                case /* float billed_income */ 5:
                    message.billedIncome = reader.float();
                    break;
                case /* float retained_income */ 6:
                    message.retainedIncome = reader.float();
                    break;
                case /* float total_billed_due */ 7:
                    message.totalBilledDue = reader.float();
                    break;
                case /* float total_billed_paid */ 8:
                    message.totalBilledPaid = reader.float();
                    break;
                case /* float over_under_billed */ 9:
                    message.overUnderBilled = reader.float();
                    break;
                case /* float suggested_catch_up_billing */ 10:
                    message.suggestedCatchUpBilling = reader.float();
                    break;
                case /* float cost_to_complete */ 11:
                    message.costToComplete = reader.float();
                    break;
                case /* float estimated_gross_margin */ 12:
                    message.estimatedGrossMargin = reader.float();
                    break;
                case /* float estimated_gross_margin_percentage */ 13:
                    message.estimatedGrossMarginPercentage = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* float percent_complete = 1; */
        if (message.percentComplete !== 0)
            writer.tag(1, WireType.Bit32).float(message.percentComplete);
        /* float budget_override = 2; */
        if (message.budgetOverride !== 0)
            writer.tag(2, WireType.Bit32).float(message.budgetOverride);
        /* float total_contract_value = 3; */
        if (message.totalContractValue !== 0)
            writer.tag(3, WireType.Bit32).float(message.totalContractValue);
        /* float earned_income = 4; */
        if (message.earnedIncome !== 0)
            writer.tag(4, WireType.Bit32).float(message.earnedIncome);
        /* float billed_income = 5; */
        if (message.billedIncome !== 0)
            writer.tag(5, WireType.Bit32).float(message.billedIncome);
        /* float retained_income = 6; */
        if (message.retainedIncome !== 0)
            writer.tag(6, WireType.Bit32).float(message.retainedIncome);
        /* float total_billed_due = 7; */
        if (message.totalBilledDue !== 0)
            writer.tag(7, WireType.Bit32).float(message.totalBilledDue);
        /* float total_billed_paid = 8; */
        if (message.totalBilledPaid !== 0)
            writer.tag(8, WireType.Bit32).float(message.totalBilledPaid);
        /* float over_under_billed = 9; */
        if (message.overUnderBilled !== 0)
            writer.tag(9, WireType.Bit32).float(message.overUnderBilled);
        /* float suggested_catch_up_billing = 10; */
        if (message.suggestedCatchUpBilling !== 0)
            writer.tag(10, WireType.Bit32).float(message.suggestedCatchUpBilling);
        /* float cost_to_complete = 11; */
        if (message.costToComplete !== 0)
            writer.tag(11, WireType.Bit32).float(message.costToComplete);
        /* float estimated_gross_margin = 12; */
        if (message.estimatedGrossMargin !== 0)
            writer.tag(12, WireType.Bit32).float(message.estimatedGrossMargin);
        /* float estimated_gross_margin_percentage = 13; */
        if (message.estimatedGrossMarginPercentage !== 0)
            writer.tag(13, WireType.Bit32).float(message.estimatedGrossMarginPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.AssociatedEstimateProgress
 */
export const AssociatedEstimateProgress = new AssociatedEstimateProgress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssociatedChangeOrder$Type extends MessageType {
    constructor() {
        super("unity_build.AssociatedChangeOrder", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "custom_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "last_updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "change_order_template_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "last_updated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "estimator_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "change_order_status_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "change_order_budget", kind: "message", T: () => ContractBudget }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.description = "";
        message.dueDate = "";
        message.createdBy = 0;
        message.dateCreated = "";
        message.name = "";
        message.customId = "";
        message.lastUpdatedBy = 0;
        message.changeOrderTemplateId = 0;
        message.lastUpdated = "";
        message.estimatorId = 0;
        message.changeOrderStatusName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string due_date */ 3:
                    message.dueDate = reader.string();
                    break;
                case /* int32 created_by */ 4:
                    message.createdBy = reader.int32();
                    break;
                case /* string date_created */ 5:
                    message.dateCreated = reader.string();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* string custom_id */ 7:
                    message.customId = reader.string();
                    break;
                case /* int32 last_updated_by */ 8:
                    message.lastUpdatedBy = reader.int32();
                    break;
                case /* int32 change_order_template_id */ 9:
                    message.changeOrderTemplateId = reader.int32();
                    break;
                case /* string last_updated */ 10:
                    message.lastUpdated = reader.string();
                    break;
                case /* int32 estimator_id */ 11:
                    message.estimatorId = reader.int32();
                    break;
                case /* string change_order_status_name */ 12:
                    message.changeOrderStatusName = reader.string();
                    break;
                case /* unity_build.ContractBudget change_order_budget */ 13:
                    message.changeOrderBudget = ContractBudget.internalBinaryRead(reader, reader.uint32(), options, message.changeOrderBudget);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string due_date = 3; */
        if (message.dueDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dueDate);
        /* int32 created_by = 4; */
        if (message.createdBy !== 0)
            writer.tag(4, WireType.Varint).int32(message.createdBy);
        /* string date_created = 5; */
        if (message.dateCreated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateCreated);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* string custom_id = 7; */
        if (message.customId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customId);
        /* int32 last_updated_by = 8; */
        if (message.lastUpdatedBy !== 0)
            writer.tag(8, WireType.Varint).int32(message.lastUpdatedBy);
        /* int32 change_order_template_id = 9; */
        if (message.changeOrderTemplateId !== 0)
            writer.tag(9, WireType.Varint).int32(message.changeOrderTemplateId);
        /* string last_updated = 10; */
        if (message.lastUpdated !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.lastUpdated);
        /* int32 estimator_id = 11; */
        if (message.estimatorId !== 0)
            writer.tag(11, WireType.Varint).int32(message.estimatorId);
        /* string change_order_status_name = 12; */
        if (message.changeOrderStatusName !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.changeOrderStatusName);
        /* unity_build.ContractBudget change_order_budget = 13; */
        if (message.changeOrderBudget)
            ContractBudget.internalBinaryWrite(message.changeOrderBudget, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.AssociatedChangeOrder
 */
export const AssociatedChangeOrder = new AssociatedChangeOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContractBudget$Type extends MessageType {
    constructor() {
        super("unity_build.ContractBudget", [
            { no: 1, name: "budget_labor_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "budget_direct_labor_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "budget_indirect_labor_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "budget_material_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "budget_quoted_material_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "budget_general_expense_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "budget_equipment_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "budget_subcontractor_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "budget_overhead_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "budget_profit", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "budget_total_estimate", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "budget_selling_price", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.budgetLaborHours = 0;
        message.budgetDirectLaborCost = 0;
        message.budgetIndirectLaborCost = 0;
        message.budgetMaterialCost = 0;
        message.budgetQuotedMaterialCost = 0;
        message.budgetGeneralExpenseCost = 0;
        message.budgetEquipmentCost = 0;
        message.budgetSubcontractorCost = 0;
        message.budgetOverheadCost = 0;
        message.budgetProfit = 0;
        message.budgetTotalEstimate = 0;
        message.budgetSellingPrice = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float budget_labor_hours */ 1:
                    message.budgetLaborHours = reader.float();
                    break;
                case /* float budget_direct_labor_cost */ 2:
                    message.budgetDirectLaborCost = reader.float();
                    break;
                case /* float budget_indirect_labor_cost */ 3:
                    message.budgetIndirectLaborCost = reader.float();
                    break;
                case /* float budget_material_cost */ 4:
                    message.budgetMaterialCost = reader.float();
                    break;
                case /* float budget_quoted_material_cost */ 5:
                    message.budgetQuotedMaterialCost = reader.float();
                    break;
                case /* float budget_general_expense_cost */ 6:
                    message.budgetGeneralExpenseCost = reader.float();
                    break;
                case /* float budget_equipment_cost */ 7:
                    message.budgetEquipmentCost = reader.float();
                    break;
                case /* float budget_subcontractor_cost */ 8:
                    message.budgetSubcontractorCost = reader.float();
                    break;
                case /* float budget_overhead_cost */ 9:
                    message.budgetOverheadCost = reader.float();
                    break;
                case /* float budget_profit */ 10:
                    message.budgetProfit = reader.float();
                    break;
                case /* float budget_total_estimate */ 11:
                    message.budgetTotalEstimate = reader.float();
                    break;
                case /* float budget_selling_price */ 12:
                    message.budgetSellingPrice = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* float budget_labor_hours = 1; */
        if (message.budgetLaborHours !== 0)
            writer.tag(1, WireType.Bit32).float(message.budgetLaborHours);
        /* float budget_direct_labor_cost = 2; */
        if (message.budgetDirectLaborCost !== 0)
            writer.tag(2, WireType.Bit32).float(message.budgetDirectLaborCost);
        /* float budget_indirect_labor_cost = 3; */
        if (message.budgetIndirectLaborCost !== 0)
            writer.tag(3, WireType.Bit32).float(message.budgetIndirectLaborCost);
        /* float budget_material_cost = 4; */
        if (message.budgetMaterialCost !== 0)
            writer.tag(4, WireType.Bit32).float(message.budgetMaterialCost);
        /* float budget_quoted_material_cost = 5; */
        if (message.budgetQuotedMaterialCost !== 0)
            writer.tag(5, WireType.Bit32).float(message.budgetQuotedMaterialCost);
        /* float budget_general_expense_cost = 6; */
        if (message.budgetGeneralExpenseCost !== 0)
            writer.tag(6, WireType.Bit32).float(message.budgetGeneralExpenseCost);
        /* float budget_equipment_cost = 7; */
        if (message.budgetEquipmentCost !== 0)
            writer.tag(7, WireType.Bit32).float(message.budgetEquipmentCost);
        /* float budget_subcontractor_cost = 8; */
        if (message.budgetSubcontractorCost !== 0)
            writer.tag(8, WireType.Bit32).float(message.budgetSubcontractorCost);
        /* float budget_overhead_cost = 9; */
        if (message.budgetOverheadCost !== 0)
            writer.tag(9, WireType.Bit32).float(message.budgetOverheadCost);
        /* float budget_profit = 10; */
        if (message.budgetProfit !== 0)
            writer.tag(10, WireType.Bit32).float(message.budgetProfit);
        /* float budget_total_estimate = 11; */
        if (message.budgetTotalEstimate !== 0)
            writer.tag(11, WireType.Bit32).float(message.budgetTotalEstimate);
        /* float budget_selling_price = 12; */
        if (message.budgetSellingPrice !== 0)
            writer.tag(12, WireType.Bit32).float(message.budgetSellingPrice);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.ContractBudget
 */
export const ContractBudget = new ContractBudget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIGetContractsRequest$Type extends MessageType {
    constructor() {
        super("unity_build.APIGetContractsRequest", [
            { no: 1, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "apiKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.ids = [];
        message.apiKey = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string ids */ 1:
                    message.ids.push(reader.string());
                    break;
                case /* string apiKey */ 2:
                    message.apiKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string ids = 1; */
        for (let i = 0; i < message.ids.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.ids[i]);
        /* string apiKey = 2; */
        if (message.apiKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.apiKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIGetContractsRequest
 */
export const APIGetContractsRequest = new APIGetContractsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIGetContractsResponse$Type extends MessageType {
    constructor() {
        super("unity_build.APIGetContractsResponse", [
            { no: 1, name: "contracts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIContract },
            { no: 2, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contracts = [];
        message.success = false;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated unity_build.APIContract contracts */ 1:
                    message.contracts.push(APIContract.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool success */ 2:
                    message.success = reader.bool();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated unity_build.APIContract contracts = 1; */
        for (let i = 0; i < message.contracts.length; i++)
            APIContract.internalBinaryWrite(message.contracts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool success = 2; */
        if (message.success !== false)
            writer.tag(2, WireType.Varint).bool(message.success);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIGetContractsResponse
 */
export const APIGetContractsResponse = new APIGetContractsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIContract$Type extends MessageType {
    constructor() {
        super("unity_build.APIContract", [
            { no: 1, name: "contractId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "projectId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dateCreated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "lastUpdated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "contractName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "contractDescription", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "associatedEstimates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIAssociatedEstimate },
            { no: 9, name: "primeContractValue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "primeContractTotalApprovedChangeOrders", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "primeContractTotalCurrentContractValue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "totalBudgetLaborHours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "totalBudget", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 14, name: "projectURLs", kind: "message", T: () => APIProjectURLs }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = "";
        message.customId = "";
        message.projectId = "";
        message.dateCreated = "";
        message.lastUpdated = "";
        message.contractName = "";
        message.contractDescription = "";
        message.associatedEstimates = [];
        message.primeContractValue = 0;
        message.primeContractTotalApprovedChangeOrders = 0;
        message.primeContractTotalCurrentContractValue = 0;
        message.totalBudgetLaborHours = 0;
        message.totalBudget = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string contractId */ 1:
                    message.contractId = reader.string();
                    break;
                case /* string customId */ 2:
                    message.customId = reader.string();
                    break;
                case /* string projectId */ 3:
                    message.projectId = reader.string();
                    break;
                case /* string dateCreated */ 4:
                    message.dateCreated = reader.string();
                    break;
                case /* string lastUpdated */ 5:
                    message.lastUpdated = reader.string();
                    break;
                case /* string contractName */ 6:
                    message.contractName = reader.string();
                    break;
                case /* string contractDescription */ 7:
                    message.contractDescription = reader.string();
                    break;
                case /* repeated unity_build.APIAssociatedEstimate associatedEstimates */ 8:
                    message.associatedEstimates.push(APIAssociatedEstimate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* float primeContractValue */ 9:
                    message.primeContractValue = reader.float();
                    break;
                case /* float primeContractTotalApprovedChangeOrders */ 10:
                    message.primeContractTotalApprovedChangeOrders = reader.float();
                    break;
                case /* float primeContractTotalCurrentContractValue */ 11:
                    message.primeContractTotalCurrentContractValue = reader.float();
                    break;
                case /* float totalBudgetLaborHours */ 12:
                    message.totalBudgetLaborHours = reader.float();
                    break;
                case /* float totalBudget */ 13:
                    message.totalBudget = reader.float();
                    break;
                case /* unity_build.APIProjectURLs projectURLs */ 14:
                    message.projectURLs = APIProjectURLs.internalBinaryRead(reader, reader.uint32(), options, message.projectURLs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string contractId = 1; */
        if (message.contractId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.contractId);
        /* string customId = 2; */
        if (message.customId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customId);
        /* string projectId = 3; */
        if (message.projectId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.projectId);
        /* string dateCreated = 4; */
        if (message.dateCreated !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dateCreated);
        /* string lastUpdated = 5; */
        if (message.lastUpdated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.lastUpdated);
        /* string contractName = 6; */
        if (message.contractName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.contractName);
        /* string contractDescription = 7; */
        if (message.contractDescription !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.contractDescription);
        /* repeated unity_build.APIAssociatedEstimate associatedEstimates = 8; */
        for (let i = 0; i < message.associatedEstimates.length; i++)
            APIAssociatedEstimate.internalBinaryWrite(message.associatedEstimates[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* float primeContractValue = 9; */
        if (message.primeContractValue !== 0)
            writer.tag(9, WireType.Bit32).float(message.primeContractValue);
        /* float primeContractTotalApprovedChangeOrders = 10; */
        if (message.primeContractTotalApprovedChangeOrders !== 0)
            writer.tag(10, WireType.Bit32).float(message.primeContractTotalApprovedChangeOrders);
        /* float primeContractTotalCurrentContractValue = 11; */
        if (message.primeContractTotalCurrentContractValue !== 0)
            writer.tag(11, WireType.Bit32).float(message.primeContractTotalCurrentContractValue);
        /* float totalBudgetLaborHours = 12; */
        if (message.totalBudgetLaborHours !== 0)
            writer.tag(12, WireType.Bit32).float(message.totalBudgetLaborHours);
        /* float totalBudget = 13; */
        if (message.totalBudget !== 0)
            writer.tag(13, WireType.Bit32).float(message.totalBudget);
        /* unity_build.APIProjectURLs projectURLs = 14; */
        if (message.projectURLs)
            APIProjectURLs.internalBinaryWrite(message.projectURLs, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIContract
 */
export const APIContract = new APIContract$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIProjectURLs$Type extends MessageType {
    constructor() {
        super("unity_build.APIProjectURLs", [
            { no: 1, name: "projectPlanroomURL", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "projectContractURL", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.projectPlanroomURL = "";
        message.projectContractURL = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string projectPlanroomURL */ 1:
                    message.projectPlanroomURL = reader.string();
                    break;
                case /* string projectContractURL */ 2:
                    message.projectContractURL = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string projectPlanroomURL = 1; */
        if (message.projectPlanroomURL !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.projectPlanroomURL);
        /* string projectContractURL = 2; */
        if (message.projectContractURL !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.projectContractURL);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIProjectURLs
 */
export const APIProjectURLs = new APIProjectURLs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIAssociatedEstimate$Type extends MessageType {
    constructor() {
        super("unity_build.APIAssociatedEstimate", [
            { no: 1, name: "estimateId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "contractId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "projectId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "dueDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "dateCreated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "customId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "lastUpdated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "masterFormatDivisionName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "estimateStatusId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "estimateStatusName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "estimateBudget", kind: "message", T: () => APIContractBudget },
            { no: 17, name: "associatedChangeOrders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => APIAssociatedChangeOrder },
            { no: 18, name: "masterFormatDivisionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "isPrimeProject", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "progress", kind: "message", T: () => APIAssociatedEstimateProgress }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.estimateId = "";
        message.contractId = "";
        message.projectId = "";
        message.description = "";
        message.dueDate = "";
        message.dateCreated = "";
        message.name = "";
        message.customId = "";
        message.lastUpdated = "";
        message.masterFormatDivisionName = "";
        message.estimateStatusId = "";
        message.estimateStatusName = "";
        message.associatedChangeOrders = [];
        message.masterFormatDivisionId = "";
        message.isPrimeProject = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string estimateId */ 1:
                    message.estimateId = reader.string();
                    break;
                case /* string contractId */ 2:
                    message.contractId = reader.string();
                    break;
                case /* string projectId */ 3:
                    message.projectId = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string dueDate */ 5:
                    message.dueDate = reader.string();
                    break;
                case /* string dateCreated */ 6:
                    message.dateCreated = reader.string();
                    break;
                case /* string name */ 7:
                    message.name = reader.string();
                    break;
                case /* string customId */ 8:
                    message.customId = reader.string();
                    break;
                case /* string lastUpdated */ 11:
                    message.lastUpdated = reader.string();
                    break;
                case /* string masterFormatDivisionName */ 13:
                    message.masterFormatDivisionName = reader.string();
                    break;
                case /* string estimateStatusId */ 14:
                    message.estimateStatusId = reader.string();
                    break;
                case /* string estimateStatusName */ 15:
                    message.estimateStatusName = reader.string();
                    break;
                case /* unity_build.APIContractBudget estimateBudget */ 16:
                    message.estimateBudget = APIContractBudget.internalBinaryRead(reader, reader.uint32(), options, message.estimateBudget);
                    break;
                case /* repeated unity_build.APIAssociatedChangeOrder associatedChangeOrders */ 17:
                    message.associatedChangeOrders.push(APIAssociatedChangeOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string masterFormatDivisionId */ 18:
                    message.masterFormatDivisionId = reader.string();
                    break;
                case /* bool isPrimeProject */ 19:
                    message.isPrimeProject = reader.bool();
                    break;
                case /* unity_build.APIAssociatedEstimateProgress progress */ 20:
                    message.progress = APIAssociatedEstimateProgress.internalBinaryRead(reader, reader.uint32(), options, message.progress);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string estimateId = 1; */
        if (message.estimateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.estimateId);
        /* string contractId = 2; */
        if (message.contractId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.contractId);
        /* string projectId = 3; */
        if (message.projectId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.projectId);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string dueDate = 5; */
        if (message.dueDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dueDate);
        /* string dateCreated = 6; */
        if (message.dateCreated !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateCreated);
        /* string name = 7; */
        if (message.name !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.name);
        /* string customId = 8; */
        if (message.customId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.customId);
        /* string lastUpdated = 11; */
        if (message.lastUpdated !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.lastUpdated);
        /* string masterFormatDivisionName = 13; */
        if (message.masterFormatDivisionName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.masterFormatDivisionName);
        /* string estimateStatusId = 14; */
        if (message.estimateStatusId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.estimateStatusId);
        /* string estimateStatusName = 15; */
        if (message.estimateStatusName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.estimateStatusName);
        /* unity_build.APIContractBudget estimateBudget = 16; */
        if (message.estimateBudget)
            APIContractBudget.internalBinaryWrite(message.estimateBudget, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated unity_build.APIAssociatedChangeOrder associatedChangeOrders = 17; */
        for (let i = 0; i < message.associatedChangeOrders.length; i++)
            APIAssociatedChangeOrder.internalBinaryWrite(message.associatedChangeOrders[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* string masterFormatDivisionId = 18; */
        if (message.masterFormatDivisionId !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.masterFormatDivisionId);
        /* bool isPrimeProject = 19; */
        if (message.isPrimeProject !== false)
            writer.tag(19, WireType.Varint).bool(message.isPrimeProject);
        /* unity_build.APIAssociatedEstimateProgress progress = 20; */
        if (message.progress)
            APIAssociatedEstimateProgress.internalBinaryWrite(message.progress, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIAssociatedEstimate
 */
export const APIAssociatedEstimate = new APIAssociatedEstimate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIAssociatedEstimateProgress$Type extends MessageType {
    constructor() {
        super("unity_build.APIAssociatedEstimateProgress", [
            { no: 1, name: "percentComplete", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "budgetOverride", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "totalContractValue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "earnedIncome", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "billedIncome", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "retainedIncome", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "totalBilledDue", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "totalBilledPaid", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "overUnderBilled", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "suggestedCatchUpBilling", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "costToComplete", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "estimatedGrossMargin", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "estimatedGrossMarginPercentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.percentComplete = 0;
        message.budgetOverride = 0;
        message.totalContractValue = 0;
        message.earnedIncome = 0;
        message.billedIncome = 0;
        message.retainedIncome = 0;
        message.totalBilledDue = 0;
        message.totalBilledPaid = 0;
        message.overUnderBilled = 0;
        message.suggestedCatchUpBilling = 0;
        message.costToComplete = 0;
        message.estimatedGrossMargin = 0;
        message.estimatedGrossMarginPercentage = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float percentComplete */ 1:
                    message.percentComplete = reader.float();
                    break;
                case /* float budgetOverride */ 2:
                    message.budgetOverride = reader.float();
                    break;
                case /* float totalContractValue */ 3:
                    message.totalContractValue = reader.float();
                    break;
                case /* float earnedIncome */ 4:
                    message.earnedIncome = reader.float();
                    break;
                case /* float billedIncome */ 5:
                    message.billedIncome = reader.float();
                    break;
                case /* float retainedIncome */ 6:
                    message.retainedIncome = reader.float();
                    break;
                case /* float totalBilledDue */ 7:
                    message.totalBilledDue = reader.float();
                    break;
                case /* float totalBilledPaid */ 8:
                    message.totalBilledPaid = reader.float();
                    break;
                case /* float overUnderBilled */ 9:
                    message.overUnderBilled = reader.float();
                    break;
                case /* float suggestedCatchUpBilling */ 10:
                    message.suggestedCatchUpBilling = reader.float();
                    break;
                case /* float costToComplete */ 11:
                    message.costToComplete = reader.float();
                    break;
                case /* float estimatedGrossMargin */ 12:
                    message.estimatedGrossMargin = reader.float();
                    break;
                case /* float estimatedGrossMarginPercentage */ 13:
                    message.estimatedGrossMarginPercentage = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* float percentComplete = 1; */
        if (message.percentComplete !== 0)
            writer.tag(1, WireType.Bit32).float(message.percentComplete);
        /* float budgetOverride = 2; */
        if (message.budgetOverride !== 0)
            writer.tag(2, WireType.Bit32).float(message.budgetOverride);
        /* float totalContractValue = 3; */
        if (message.totalContractValue !== 0)
            writer.tag(3, WireType.Bit32).float(message.totalContractValue);
        /* float earnedIncome = 4; */
        if (message.earnedIncome !== 0)
            writer.tag(4, WireType.Bit32).float(message.earnedIncome);
        /* float billedIncome = 5; */
        if (message.billedIncome !== 0)
            writer.tag(5, WireType.Bit32).float(message.billedIncome);
        /* float retainedIncome = 6; */
        if (message.retainedIncome !== 0)
            writer.tag(6, WireType.Bit32).float(message.retainedIncome);
        /* float totalBilledDue = 7; */
        if (message.totalBilledDue !== 0)
            writer.tag(7, WireType.Bit32).float(message.totalBilledDue);
        /* float totalBilledPaid = 8; */
        if (message.totalBilledPaid !== 0)
            writer.tag(8, WireType.Bit32).float(message.totalBilledPaid);
        /* float overUnderBilled = 9; */
        if (message.overUnderBilled !== 0)
            writer.tag(9, WireType.Bit32).float(message.overUnderBilled);
        /* float suggestedCatchUpBilling = 10; */
        if (message.suggestedCatchUpBilling !== 0)
            writer.tag(10, WireType.Bit32).float(message.suggestedCatchUpBilling);
        /* float costToComplete = 11; */
        if (message.costToComplete !== 0)
            writer.tag(11, WireType.Bit32).float(message.costToComplete);
        /* float estimatedGrossMargin = 12; */
        if (message.estimatedGrossMargin !== 0)
            writer.tag(12, WireType.Bit32).float(message.estimatedGrossMargin);
        /* float estimatedGrossMarginPercentage = 13; */
        if (message.estimatedGrossMarginPercentage !== 0)
            writer.tag(13, WireType.Bit32).float(message.estimatedGrossMarginPercentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIAssociatedEstimateProgress
 */
export const APIAssociatedEstimateProgress = new APIAssociatedEstimateProgress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIAssociatedChangeOrder$Type extends MessageType {
    constructor() {
        super("unity_build.APIAssociatedChangeOrder", [
            { no: 1, name: "changeOrderId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dueDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "dateCreated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "customId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "lastUpdated", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "changeOrderStatusId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "changeOrderStatusName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "changeOrderBudget", kind: "message", T: () => APIContractBudget },
            { no: 14, name: "contractId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.changeOrderId = "";
        message.description = "";
        message.dueDate = "";
        message.dateCreated = "";
        message.name = "";
        message.customId = "";
        message.lastUpdated = "";
        message.changeOrderStatusId = "";
        message.changeOrderStatusName = "";
        message.contractId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string changeOrderId */ 1:
                    message.changeOrderId = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string dueDate */ 3:
                    message.dueDate = reader.string();
                    break;
                case /* string dateCreated */ 5:
                    message.dateCreated = reader.string();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* string customId */ 7:
                    message.customId = reader.string();
                    break;
                case /* string lastUpdated */ 10:
                    message.lastUpdated = reader.string();
                    break;
                case /* string changeOrderStatusId */ 11:
                    message.changeOrderStatusId = reader.string();
                    break;
                case /* string changeOrderStatusName */ 12:
                    message.changeOrderStatusName = reader.string();
                    break;
                case /* unity_build.APIContractBudget changeOrderBudget */ 13:
                    message.changeOrderBudget = APIContractBudget.internalBinaryRead(reader, reader.uint32(), options, message.changeOrderBudget);
                    break;
                case /* string contractId */ 14:
                    message.contractId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string changeOrderId = 1; */
        if (message.changeOrderId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.changeOrderId);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string dueDate = 3; */
        if (message.dueDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dueDate);
        /* string dateCreated = 5; */
        if (message.dateCreated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateCreated);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* string customId = 7; */
        if (message.customId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customId);
        /* string lastUpdated = 10; */
        if (message.lastUpdated !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.lastUpdated);
        /* string changeOrderStatusId = 11; */
        if (message.changeOrderStatusId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.changeOrderStatusId);
        /* string changeOrderStatusName = 12; */
        if (message.changeOrderStatusName !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.changeOrderStatusName);
        /* unity_build.APIContractBudget changeOrderBudget = 13; */
        if (message.changeOrderBudget)
            APIContractBudget.internalBinaryWrite(message.changeOrderBudget, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string contractId = 14; */
        if (message.contractId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.contractId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIAssociatedChangeOrder
 */
export const APIAssociatedChangeOrder = new APIAssociatedChangeOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class APIContractBudget$Type extends MessageType {
    constructor() {
        super("unity_build.APIContractBudget", [
            { no: 1, name: "budgetLaborHours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 2, name: "budgetDirectLaborCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "budgetIndirectLaborCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "budgetMaterialCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "budgetQuotedMaterialCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "budgetGeneralExpenseCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "budgetEquipmentCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "budgetSubcontractorCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "budgetOverheadCost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "budgetProfit", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "budgetTotalEstimate", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "budgetSellingPrice", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.budgetLaborHours = 0;
        message.budgetDirectLaborCost = 0;
        message.budgetIndirectLaborCost = 0;
        message.budgetMaterialCost = 0;
        message.budgetQuotedMaterialCost = 0;
        message.budgetGeneralExpenseCost = 0;
        message.budgetEquipmentCost = 0;
        message.budgetSubcontractorCost = 0;
        message.budgetOverheadCost = 0;
        message.budgetProfit = 0;
        message.budgetTotalEstimate = 0;
        message.budgetSellingPrice = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* float budgetLaborHours */ 1:
                    message.budgetLaborHours = reader.float();
                    break;
                case /* float budgetDirectLaborCost */ 2:
                    message.budgetDirectLaborCost = reader.float();
                    break;
                case /* float budgetIndirectLaborCost */ 3:
                    message.budgetIndirectLaborCost = reader.float();
                    break;
                case /* float budgetMaterialCost */ 4:
                    message.budgetMaterialCost = reader.float();
                    break;
                case /* float budgetQuotedMaterialCost */ 5:
                    message.budgetQuotedMaterialCost = reader.float();
                    break;
                case /* float budgetGeneralExpenseCost */ 6:
                    message.budgetGeneralExpenseCost = reader.float();
                    break;
                case /* float budgetEquipmentCost */ 7:
                    message.budgetEquipmentCost = reader.float();
                    break;
                case /* float budgetSubcontractorCost */ 8:
                    message.budgetSubcontractorCost = reader.float();
                    break;
                case /* float budgetOverheadCost */ 9:
                    message.budgetOverheadCost = reader.float();
                    break;
                case /* float budgetProfit */ 10:
                    message.budgetProfit = reader.float();
                    break;
                case /* float budgetTotalEstimate */ 11:
                    message.budgetTotalEstimate = reader.float();
                    break;
                case /* float budgetSellingPrice */ 12:
                    message.budgetSellingPrice = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* float budgetLaborHours = 1; */
        if (message.budgetLaborHours !== 0)
            writer.tag(1, WireType.Bit32).float(message.budgetLaborHours);
        /* float budgetDirectLaborCost = 2; */
        if (message.budgetDirectLaborCost !== 0)
            writer.tag(2, WireType.Bit32).float(message.budgetDirectLaborCost);
        /* float budgetIndirectLaborCost = 3; */
        if (message.budgetIndirectLaborCost !== 0)
            writer.tag(3, WireType.Bit32).float(message.budgetIndirectLaborCost);
        /* float budgetMaterialCost = 4; */
        if (message.budgetMaterialCost !== 0)
            writer.tag(4, WireType.Bit32).float(message.budgetMaterialCost);
        /* float budgetQuotedMaterialCost = 5; */
        if (message.budgetQuotedMaterialCost !== 0)
            writer.tag(5, WireType.Bit32).float(message.budgetQuotedMaterialCost);
        /* float budgetGeneralExpenseCost = 6; */
        if (message.budgetGeneralExpenseCost !== 0)
            writer.tag(6, WireType.Bit32).float(message.budgetGeneralExpenseCost);
        /* float budgetEquipmentCost = 7; */
        if (message.budgetEquipmentCost !== 0)
            writer.tag(7, WireType.Bit32).float(message.budgetEquipmentCost);
        /* float budgetSubcontractorCost = 8; */
        if (message.budgetSubcontractorCost !== 0)
            writer.tag(8, WireType.Bit32).float(message.budgetSubcontractorCost);
        /* float budgetOverheadCost = 9; */
        if (message.budgetOverheadCost !== 0)
            writer.tag(9, WireType.Bit32).float(message.budgetOverheadCost);
        /* float budgetProfit = 10; */
        if (message.budgetProfit !== 0)
            writer.tag(10, WireType.Bit32).float(message.budgetProfit);
        /* float budgetTotalEstimate = 11; */
        if (message.budgetTotalEstimate !== 0)
            writer.tag(11, WireType.Bit32).float(message.budgetTotalEstimate);
        /* float budgetSellingPrice = 12; */
        if (message.budgetSellingPrice !== 0)
            writer.tag(12, WireType.Bit32).float(message.budgetSellingPrice);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message unity_build.APIContractBudget
 */
export const APIContractBudget = new APIContractBudget$Type();
/**
 * @generated ServiceType for protobuf service unity_build.UnityBuildService
 */
export const UnityBuildService = new ServiceType("unity_build.UnityBuildService", [
    { name: "GetContracts", options: {}, I: GetContractsRequest, O: GetContractsResponse },
    { name: "GetContractByCustomId", options: {}, I: GetContractByCustomIdRequest, O: Contract }
]);
